<template>
    <div>
        <!-- <h6 class="heading-small text-muted mb-4">Order Items</h6> -->

        <b-modal
            ref="importModal"
            :title="modalTitle"
            @ok="importItems"
            size="lg"
        >
            <b-card no-body>
                <b-tabs card>
                    <b-tab :title="tabOneTitle" active>
                        <b-card-body>
                            <b-table
                                v-if="is_items_mode"
                                :items="items"
                                :fields="fields"
                            >
                                <template #head(id)>
                                    <h6 class="pr-2" style="font-weight: bold">
                                        No
                                    </h6>
                                </template>
                                <template #head(order_item_type_id)>
                                    <h6 class="pr-2" style="font-weight: bold">
                                        Type
                                    </h6>
                                </template>
                                <template #cell(id)="{ index }">
                                    <h6>
                                        {{ index + 1 }}
                                    </h6>
                                </template>

                                <template #cell(order_item_type_id)="{ value }">
                                    <h6>
                                        {{ value | filterTypeName(itemTypes) }}
                                    </h6>
                                </template>
                            </b-table>

                            <show-recent-orders
                                v-if="!is_items_mode && is_recent_import"
                                v-model="selected_order_id"
                                :order_type_id="orderModel.order_type_id"
                                :customer_id="orderModel.customer_id"
                                @set-items="items => setRecentOrderItems(items)"
                            />

                            <select-order-template
                                v-if="!is_items_mode && !is_recent_import"
                                v-model="order_template_id"
                                :include-items="true"
                                :order-type-id="orderModel.order_type_id"
                                title=""
                                @set-items="items => setTemplateItems(items)"
                            />
                        </b-card-body>
                    </b-tab>
                    <b-tab
                        title="Linked Assets"
                        :disabled="!orderModel.customer_id"
                    >
                        <b-card-body>
                            <view-assets
                                v-model="linked_assets"
                                :customer_id="orderModel.customer_id"
                                :customer-assets="customerAssets"
                                :disabled="false"
                            />
                        </b-card-body>
                    </b-tab>
                </b-tabs>
            </b-card>

            <template #modal-footer="{ ok, cancel }">
                <b-button
                    v-if="is_items_mode"
                    size="sm"
                    variant="light"
                    @click="clearItems"
                >
                    <b-icon icon="arrow-clockwise"></b-icon>
                </b-button>

                <b-button
                    size="sm"
                    variant="success"
                    @click="ok()"
                    v-if="is_items_mode"
                >
                    Import Items
                </b-button>

                <b-button size="sm" variant="danger" @click="cancel()">
                    Cancel
                </b-button>
            </template>
        </b-modal>

        <!-- Accordian -->
        <template>
            <div>
                <b-row>
                    <b-col class="text-right"
                        ><b-button-group class="text-right">
                            <b-button
                                @click="showItemModal(true)"
                                size="sm"
                                variant="light"
                                title="Generate Items from a Recent activity"
                                v-b-tooltip.hover
                                :disabled="!orderModel.customer_id"
                            >
                                <b-icon icon="clock-history"></b-icon>
                            </b-button>

                            <b-button
                                @click="showItemModal(false)"
                                size="sm"
                                variant="light"
                                title="Generate Items from Template"
                                v-b-tooltip.hover
                            >
                                <b-icon icon="funnel"></b-icon>
                            </b-button>
                            <b-button
                                size="sm"
                                variant="light"
                                v-if="
                                    hasPermissionCreate && !orderModel.completed
                                "
                                @click="setItemView"
                                title="Add Item"
                                v-b-tooltip.hover
                            >
                                <b-icon-plus-circle></b-icon-plus-circle>
                            </b-button> </b-button-group
                    ></b-col>
                </b-row>
            </div>

            <div v-for="(item, idx) in filteredItemTypeOptions" :key="item.id">
                <b-btn
                    block
                    href="#"
                    v-b-toggle="'accordion' + item.id"
                    variant="light"
                    class="text-left"
                >
                    <span v-if="accordianModelArray[idx]"
                        ><b-icon icon="dash-square"></b-icon
                    ></span>
                    <span v-else
                        ><b-icon icon="plus-square-fill"></b-icon
                    ></span>
                    <span> {{ item.name }}</span>
                </b-btn>

                <b-collapse
                    :id="'accordion' + item.id"
                    role="tabpanel"
                    v-model="accordianModelArray[idx]"
                >
                    <DisplayOrderItems
                        @toggleAssignment="hideTotals = $event"
                        :filtered-items="
                            storedItems.filter(
                                x => x.order_item_type_id == item.id
                            )
                        "
                        :customer-assets="customerAssets"
                        :item-type-id="item.id"
                        @view-item="setItemView"
                        @order-status="getOrderCompletionStatus"
                    >
                    </DisplayOrderItems>
                </b-collapse>
            </div>
        </template>
        <!-- End Accordian -->

        <!-- </display-order-items> -->

        <view-item
            :order-model="orderModel"
            ref="viewItem"
            :officer="officer"
            :customer-assets="customerAssets"
        />

        <div>
            <b-row v-if="storedItems.length != 0 && (!viewMode || !hideTotals)">
                <b-col cols="9">
                    <b class="float-right">Total</b>
                </b-col>
                <b-col cols="3" style="text-align: right">
                    <b>${{ orderPricing.total | currency }}</b>
                </b-col>
            </b-row>

            <b-row v-if="storedItems.length != 0 && (!viewMode || !hideTotals)">
                <b-col cols="9">
                    <b class="float-right">Total Tax</b>
                </b-col>
                <b-col cols="3" style="text-align: right">
                    <span>${{ orderPricing.tax | currency }}</span>
                </b-col>
            </b-row>

            <b-row v-if="storedItems.length != 0 && (!viewMode || !hideTotals)">
                <b-col cols="9">
                    <b class="float-right">Grand Total</b>
                </b-col>
                <b-col cols="3" style="text-align: right">
                    <b
                        >${{
                            (orderPricing.tax + orderPricing.total) | currency
                        }}</b
                    >
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import EventBus from '@/exports/event-bus.js'
import DisplayOrderItems from './DisplayOrderItems.vue'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

import ViewItem from './ViewItem'
import SelectOrderTemplate from '@/components/SelectOrderTemplate.vue'
import ShowRecentOrders from './ShowRecentOrders.vue'

import ViewAssets from '@/components/ViewAssets'

export default {
    name: 'orders-items',
    components: {
        DisplayOrderItems,
        ViewItem,
        SelectOrderTemplate,
        ShowRecentOrders,
        ViewAssets,
    },
    mixins: [popupMixins, permissionsMixins],
    data() {
        return {
            accordianModelArray: [],
            submitting: false,
            hideTotals: false,
            orderModel: {},
            linked_assets: [],
            /////////////////////
            order_template_id: null,
            selected_order_id: null,
            is_recent_import: false,
            is_items_mode: false,
            fields: ['id', 'name', 'order_item_type_id', 'quantity'],
            items: [],
            visible: [0],
            loadedItemTypes: [],
            orderStatus: 0,
            collapseIndex: null,
        }
    },
    props: {
        viewMode: { type: Boolean, default: false },
        customerAssets: { type: Array, require: true },
    },
    filters: {
        currency: num => {
            num = parseFloat(num)
            try {
                return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
            } catch (err) {
                return '0.00'
            }
        },
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
        displayTypeName(id, types) {
            console.log('types', types)
            return (types.find(x => x.id == id) || {}).name
        },
        filterTypeName(value, types) {
            return (types.find(x => x.id == value) || {}).name
        },
    },

    computed: {
        modalTitle() {
            return this.is_items_mode && this.is_recent_import
                ? 'Selected Activity Items'
                : this.is_items_mode
                ? 'Selected Template Items'
                : this.is_recent_import
                ? 'Recent Activities'
                : 'Activity Templates'
        },
        tabOneTitle() {
            return this.is_items_mode
                ? 'Items'
                : this.is_recent_import
                ? 'Orders'
                : 'Templates'
        },
        itemTypeOptions() {
            return this.itemTypes.map(x => ({
                value: x.id,
                text: x.name,
            }))
        },

        filteredItemTypeOptions() {
            const { itemTypes } = this
            if (!itemTypes) return []
            const onlyUnique = (value, index, array) =>
                array.indexOf(value) === index

            const selectedItemType = id => itemTypes.find(t => t.id == id)

            const list = this.storedItems
                .map(i => i.order_item_type_id)
                .filter(onlyUnique)
                .map(selectedItemType)

            console.log('filteredItemTypeOptions', list)

            return list

            /*   const itemTypes = []
            for (const item of this.storedItems) {
                const idx = itemTypes.findIndex(
                    x => x == item.order_item_type_id
                )

                if (idx < 0) {
                    itemTypes.push(item.order_item_type_id)
                }
            }
            const { itemTypeOptions } = this
            return itemTypes.map(x => itemTypeOptions.find(y => y.value == x)) */
        },

        storedItems() {
            return this.$store.state.orderItemStore.items
        },

        itemTypes() {
            return this.$store.state.itemType.items
        },

        orderPricing() {
            return this.$store.getters['orderItemStore/orderPricing']
        },

        officer() {
            return this.$store.state.users.user
        },

        orderItems() {
            return this.$store.state.orders.orderItems
        },
    },
    watch: {
        officer: {
            handler: function (_officer, from) {
                console.log('ManageOrderItems watch officer', {
                    _officer,
                    from,
                })
                const { location_section_id } = _officer
                this.$store.dispatch(
                    'masterItem/fetchBySection',
                    location_section_id
                )
            },
            deep: true,
        },
        storedItems: {
            handler: function (items) {
                console.log('stored items', items)
            },
            deep: true,
        },
        orderItems: {
            //load items
            handler: function (items) {
                this.loaditems(items, 'watched')
            },
            deep: true,
        },

        filteredItemTypeOptions: {
            handler: function (val) {
                this.generateItems(val)
            },
            deep: true,
        },
        /*  'orderModel.linked_assets': {
            handler: function (linked_assets) {
                EventBus.$emit('update-assets', linked_assets)
            },
            deep: true,
        }, */
    },

    mounted() {
        const { orderItems } = this
        this.loaditems(orderItems, 'mounted')
        this.loadedItemTypes = this.getLoadedItemTypes(orderItems)
        //Set the visible array. This array controls the visible accordian tabs
        // this.visible =  [...Array(this.loaditems.length)].fill(true)
        console.log('this.storedItems', this.storedItems)
        this.generateItems(this.filteredItemTypeOptions)

        console.log('accordion model', this.accordianModelArray)
    },

    created() {
        EventBus.$on('trigger-add-item', () => {
            console.log('ManageOrderItems triggered........')
            this.setItemView()
        })
        EventBus.$on(
            'set-order-model',
            ({
                order: {
                    order_type_id,
                    customer_id,
                    completed,
                    driver_id,
                    delivery_location_section_id,
                },
            }) => {
                this.$nextTick(() => {
                    ///// load officer
                    console.log('set-order-model-------------------')
                    if (driver_id && this.orderModel.driver_id != driver_id) {
                        this.$store.dispatch('users/fetchUser', driver_id)
                    }

                    this.orderModel = {
                        order_type_id,
                        customer_id,
                        completed,
                        driver_id,
                        delivery_location_section_id,
                    }
                    ///console.log('EventBux Order trigger', this.orderItems)
                    // this.loaditems(this.orderItems, 'EventBus')
                })
            }
        )
    },

    methods: {
        generateItems(items) {
            this.accordianModelArray.splice(0)
            this.accordianModelArray.push(
                ...[...Array(items.length).keys()].map(() => true)
            )
        },
        loaditems(items, type) {
            console.log(`ManageOrderItems ${type}`, items)
            const cloneItems = []
            for (const item of items) {
                const _item = { ...item }
                const assets = _item.assets.map(i => i.asset_id)
                this.$set(_item, 'assets', assets)
                cloneItems.push(_item)
            }
            this.$store.dispatch('orderItemStore/load', cloneItems)
        },
        clearItems() {
            this.is_items_mode = false
            this.order_template_id = null
            this.selected_order_id = null
            this.items.splice(0, this.items.length)
        },
        showItemModal(is_recent_type) {
            this.is_recent_import = !!is_recent_type
            this.clearItems()
            this.$refs['importModal'].show()
        },

        setItemView(hash) {
            console.log('item hash', hash)
            const item = this.storedItems.find(x => x.hash === hash)
            this.$refs['viewItem'] && this.$refs['viewItem'].showItem(item)
        },
        setRecentOrderItems(items) {
            items = items || []
            console.log(
                'template items',
                items.filter(x => !x.is_secondary_order_type)
            )
            this.items.splice(0, this.items.length)
            this.items.push(
                ...items.map(({ master_item, quantity }) => ({
                    ...master_item,
                    quantity,
                }))
            )
            this.is_items_mode = true
        },
        setTemplateItems(items) {
            items = items || []
            console.log(
                'template items',
                items.filter(x => !x.is_secondary_order_type)
            )
            this.items.splice(0, this.items.length)
            this.items.push(
                ...items.map(({ master_item, default_quantity: quantity }) => ({
                    ...master_item,
                    quantity,
                }))
            )
            this.is_items_mode = true
        },
        getLoadedItemTypes(orderItems) {
            const itemTypes = orderItems

            console.log('ORDER ITEM TYPES LOADED: ', itemTypes)
            return itemTypes
        },

        toggleCollapses(ids) {
            ids.forEach(id => {
                this.$root.$emit('bv::toggle::collapse', id)
            })
        },
        getOrderCompletionStatus(value) {
            console.log('^^^^^^^^^^^ Completion Status', value)
        },

        async importItems() {
            const fixItem = item => {
                item.assets = this.linked_assets
                item.master_item_id = item.id
                item.price = item.selling_price
                item.section_from_id = null
                item.section_to_id = null
                item.id = null
            }
            for (const item of this.items) {
                fixItem(item)
                console.log('import item', item)
                await this.$store.dispatch('orderItemStore/merge', item)
            }
            this.$refs['importModal'].hide()
        },
    },
}
</script>
<style></style>
